import { render, staticRenderFns } from "./ApiTester.vue?vue&type=template&id=83f7ec42&scoped=true&"
import script from "./ApiTester.vue?vue&type=script&lang=js&"
export * from "./ApiTester.vue?vue&type=script&lang=js&"
import style0 from "./ApiTester.vue?vue&type=style&index=0&id=83f7ec42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f7ec42",
  null
  
)

export default component.exports